import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBookOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.1833 3.52691C17.0865 3.4486 16.9734 3.39297 16.8522 3.36413C16.7311 3.33529 16.6051 3.33396 16.4833 3.36024L10 4.81858L3.51667 3.34358C3.39302 3.31565 3.26463 3.3163 3.14128 3.34548C3.01792 3.37465 2.90284 3.43159 2.80481 3.51194C2.70677 3.5923 2.62836 3.69396 2.57554 3.8092C2.52272 3.92443 2.49689 4.05019 2.5 4.17691V14.3436C2.49529 14.5362 2.55749 14.7245 2.676 14.8765C2.79451 15.0284 2.96202 15.1346 3.15 15.1769L9.81667 16.6769H10.1833L16.85 15.1769C17.038 15.1346 17.2055 15.0284 17.324 14.8765C17.4425 14.7245 17.5047 14.5362 17.5 14.3436V4.17691C17.4994 4.05174 17.4707 3.92831 17.4158 3.81578C17.361 3.70325 17.2815 3.60452 17.1833 3.52691ZM4.16667 5.21858L9.16667 6.34358V14.8019L4.16667 13.6769V5.21858ZM15.8333 13.6769L10.8333 14.8019V6.34358L15.8333 5.21858V13.6769Z",
		fill: "currentColor"
	})
});
export default SvgIconBookOpen;
